type DeleteConfirmationOptions = {
  entityLabel: string;
  confirmationLabel: string;
  identifiers: Array<string | number>;
  softDelete?: boolean;
  deleteModeMessage?: string;
  extraMessage?: string;
};

function normalizeIdentifier(value: string | number): string {
  return String(value ?? '').trim();
}

export function confirmDeletionByTyping(options: DeleteConfirmationOptions): boolean {
  const normalizedIdentifiers = options.identifiers
    .map(normalizeIdentifier)
    .filter(Boolean);

  if (normalizedIdentifiers.length === 0) {
    return false;
  }

  const expectedValue = normalizedIdentifiers.join(', ');
  const entityLabel = options.entityLabel.trim() || 'record';
  const confirmationLabel = options.confirmationLabel.trim() || 'identifier';
  const deleteModeMessage = options.deleteModeMessage?.trim() || (options.softDelete
    ? 'This will soft-delete the database record only. No files or folders will be removed.'
    : 'This action cannot be undone.');
  const promptMessage = [
    `Delete ${entityLabel}?`,
    deleteModeMessage,
    options.extraMessage || '',
    `Type the ${confirmationLabel} exactly as: ${expectedValue}`,
  ]
    .filter(Boolean)
    .join('\n\n');

  const typedValue = window.prompt(promptMessage, '');
  if (typedValue === null) {
    return false;
  }

  const confirmed = typedValue.trim() === expectedValue;
  if (!confirmed) {
    window.alert(`Delete cancelled. Expected ${expectedValue}.`);
  }

  return confirmed;
}
